import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RecordingDetail, DomSnapshot } from "../declarations/interface";
import globalService from "../services/globalService";
import recordingService from "../services/recordingService";

export const getRecordingById: any = createAsyncThunk(
  "recording/getRecordingById",
  async (id: string) => {
    return recordingService.getRecordingById(id);
  }
);

export const updateRecordingName: any = createAsyncThunk(
  "recording/updateRecordingName",
  async ({ id, name }: { id: string; name: string }) => {
    return recordingService.updateRecordingName(id, name);
  }
);

export const getDomList: any = createAsyncThunk(
  "recording/getDomList",
  async ({ id, page }: { id: string; page: number }) => {
    return recordingService.getDomListByRecordingId(id, { page });
  }
);

export const reloadScreenshots: any = createAsyncThunk(
  "recording/reloadScreenshots",
  async ({ id }: { id: string }) => {
    return globalService.reloadScreenshots(id);
  }
);

export const createNewRecording: any = createAsyncThunk(
  "recording/createNewRecording",
  async ({
    recordingName,
    projectId,
    newRecordingPayload,
  }: {
    recordingName: string;
    projectId: number;
    newRecordingPayload: DomSnapshot[];
  }) => {
    return recordingService.createNewRecording(
      recordingName,
      projectId,
      newRecordingPayload
    );
  }
);

export type RecordingState = {
  recording?: RecordingDetail;
  dom_lists?: {
    total: number;
    page: number;
    limit: number;
    skip: number;
    recordingType: number;
    data: DomSnapshot[];
  };
  status: {
    type: "SUCCESS" | "FAILURE" | "ERROR";
    message: string;
    context?: any;
  } | null;
};

const DEFAULT: RecordingState = {
  status: null,
};

const slice = createSlice({
  name: "recording",
  initialState: DEFAULT,
  reducers: {
    clearStatus(state) {
      state.status = null;
    },
  },
  extraReducers: {
    [getRecordingById.fulfilled]: (state, action) => {
      state.recording = action.payload;
    },
    [getRecordingById.rejected]: (state) => {
      state.status = {
        type: "FAILURE",
        message: "Error while fetching recording details",
      };
    },
    [updateRecordingName.fulfilled]: (state) => {
      state.status = {
        type: "SUCCESS",
        message: "Recording name updated successfully",
      };
    },
    [updateRecordingName.rejected]: (state) => {
      state.status = {
        type: "FAILURE",
        message: "Error while updating recording name",
      };
    },
    [getDomList.fulfilled]: (state, action) => {
      state.dom_lists = action.payload;
    },
    [reloadScreenshots.fulfilled]: (state, action) => {
      state.status = {
        type: "SUCCESS",
        message:
          "Relaod screenshots initiated, Please wait for a while to complete the process",
      };
    },
    [reloadScreenshots.rejected]: (state) => {
      state.status = {
        type: "FAILURE",
        message: "Error while reloading screenshots",
      };
    },
    [createNewRecording.fulfilled]: (state, action) => {
      state.status = {
        type: "SUCCESS",
        message: "Recording Created Successfully",
        context: action.payload.recording_id,
      };
    },
    [createNewRecording.rejected]: (state) => {
      state.status = {
        type: "FAILURE",
        message: "Error while creating new recording",
      };
    },
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;

export default slice;
